import type * as React from "react";

/** Left-rail navigation row. */
export interface NavItemProps {
  /** Leading icon node (~17–20px). */
  icon?: React.ReactNode;
  label: React.ReactNode;
  active?: boolean;
  /** Optional trailing count. */
  count?: number;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
}

export function NavItem({ icon, label, active = false, count, onClick, style }: NavItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-current={active ? "page" : undefined}
      style={
        {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          minHeight: "42px",
          padding: "0 12px",
          border: "1px solid transparent",
          borderRadius: "var(--radius-md)",
          background: active ? "var(--accent-soft)" : "transparent",
          color: active ? "var(--accent-soft-text)" : "var(--text-secondary)",
          fontFamily: "var(--font-sans)",
          fontSize: "var(--text-body-md)",
          fontWeight: active ? "var(--fw-bold)" : "var(--fw-semibold)",
          textAlign: "left",
          cursor: "pointer",
          transition:
            "background var(--duration-fast) var(--ease-out), color var(--duration-fast) var(--ease-out)",
          ...style,
        } as React.CSSProperties
      }
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.background = "var(--surface-hover)";
          e.currentTarget.style.color = "var(--text-strong)";
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "var(--text-secondary)";
        }
      }}
    >
      <span
        style={{
          display: "grid",
          placeItems: "center",
          width: "20px",
          height: "20px",
          flex: "none",
          color: active ? "var(--accent)" : "currentColor",
        }}
      >
        {icon}
      </span>
      <span style={{ flex: 1 }}>{label}</span>
      {count != null ? (
        <span style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-micro)", fontWeight: 600, color: "var(--text-muted)" }}>
          {count}
        </span>
      ) : null}
    </button>
  );
}
